import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IChangeAnonymousCardAgencyDataTableRowFormMeta {
  PANTable: FormInputMeta,
  creationDateTable: FormInputMeta,
  effectiveDateTable: FormInputMeta,
  expTable: FormInputMeta,
  availabilityTable: FormInputMeta,
  newAgencyTable: FormInputMeta,
  schema: any,
}

const ChangeAnonymousCardAgencyDataTableRowFormMeta = {} as IChangeAnonymousCardAgencyDataTableRowFormMeta;

 
ChangeAnonymousCardAgencyDataTableRowFormMeta.PANTable = {
  name: "PANTable",
  label: "PAN",
  type: "text",
  validation: yup.string().required(),
}
ChangeAnonymousCardAgencyDataTableRowFormMeta.creationDateTable = {
  name: "creationDateTable",
  label: "Date creation",
  type: "date",
  validation: yup.string().required(),
}
ChangeAnonymousCardAgencyDataTableRowFormMeta.effectiveDateTable = {
  name: "effectiveDateTable",
  label: "Date Effective",
  type: "date",
  validation: yup.string().required(),
}
ChangeAnonymousCardAgencyDataTableRowFormMeta.expTable = {
  name: "expTable",
  label: "Exp.",
  type: "text",
  validation: yup.string().required(),
}
ChangeAnonymousCardAgencyDataTableRowFormMeta.availabilityTable = {
  name: "availabilityTable",
  label: "Disponible",
  type: "text",
  validation: yup.string().required(),
}
ChangeAnonymousCardAgencyDataTableRowFormMeta.newAgencyTable = {
  name: "newAgencyTable",
  label: "Nouvelle agence",
  type: "select",
  options:  [
    {
      label: 'Agence A',
      value: 'a'
    },
    {
      label: 'Agence B',
      value: 'b',
    },
    {
      label: 'Agence C',
      value: 'b',
    },
  ],
  validation: yup.string().required(),
}

ChangeAnonymousCardAgencyDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(ChangeAnonymousCardAgencyDataTableRowFormMeta));

export default ChangeAnonymousCardAgencyDataTableRowFormMeta;